import { Controller } from 'stimulus';

export default class extends Controller {
  static classes = ['copied', 'message'];

  static values = {
    text: String,
    feedbackDuration: { type: Number, default: 1000 },
  };

  copy(event) {
    event.preventDefault();
    navigator.clipboard.writeText(this.textValue).then(this.#showFeedback);
  }

  #showFeedback = () => {
    this.#showCopiedMessage();
    clearTimeout(this.#timeout);
    this.#timeout = setTimeout(this.#hideCopiedMessage, this.feedbackDurationValue);
  };

  #showCopiedMessage = () => {
    this.#originalHTML ??= this.element.innerHTML;
    const message =
      '<i class="fa-regular fa-check" aria-hidden="true"></i> <span class="hidden-mobile">Copied!</span>';
    // Only wrapped when a message class is set: an unconditional wrapper would make the icon and
    // the label a single child, collapsing the gap on buttons that lay their contents out with flex.
    this.element.innerHTML = this.hasMessageClass
      ? `<span class="${this.messageClass}">${message}</span>`
      : message;
    if (this.hasCopiedClass) {
      this.element.classList.add(this.copiedClass);
    }
  };

  #hideCopiedMessage = () => {
    this.element.innerHTML = this.#originalHTML;
    if (this.hasCopiedClass) {
      this.element.classList.remove(this.copiedClass);
    }
  };

  #originalHTML = null;
  #timeout = null;
}
